const page0Mutation = {
  customFunction1: ([name], state, { changeValue }) => {
    console.log("in customFunction1 function", state);
    //console.log([name]);
    //changeValue(state, name, value => value && value.toUpperCase());
  }
};

export default page0Mutation;
